import React from 'react';
import ProfileEdit from '../ProfileEdit';
// Simple wrapper for modular routing parity
const ProfileTab = () => <ProfileEdit />;
export default ProfileTab;
